module.exports = __webpack_public_path__ + "img/na.ab7ea1fc.svg";